import { WebUsbTransport } from "../usb/WebUsbTransport";

/** WebUSB bulk transport used by the public ADNL command/data framing. */
export class AmlogicUsbTransport extends WebUsbTransport {
  constructor() {
    super("AMLOGIC");
  }
}
